import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

import { queryClient } from 'components/providers/QueryProvider';
import api from 'utils/api';
import { useAuth } from 'utils/auth';

import { ConstantsQueryKey } from './useConstants';

export const useRefreshTokens = () => {
  const auth = useAuth();
  const {
    data: tokenValidResponse,
    refetch,
    isError
  } = useQuery({
    queryKey: ['isTokenValid'],
    enabled: !!auth.user && !auth.session,
    queryFn: () => api.get('/public/isTokenExpired'),
    refetchInterval: 1000 * 60 * 30 // 30 mins
  });

  useEffect(() => {
    if (isError && auth.user && !auth.session) {
      // Add some form of toast notif here. ('Refreshing tokens...')
      refetch().then(() => {
        queryClient.refetchQueries({ queryKey: ConstantsQueryKey });
      });
    }
  }, [isError]);

  return {
    tokenValidResponse
  };
};
